import request from './index'

// post
export function postRequest(url, parameter) {
  return request({
    url,
    method: 'post',
    data: parameter
  })
}

// post method= {post | put}
export function httpRequest(url, parameter, method) {
  return request({
    url,
    method,
    data: parameter
  })
}

// put
export function putRequest(url, parameter) {
  return request({
    url,
    method: 'put',
    data: parameter
  })
}

// get
export function getRequest(url, parameter) {
  return request({
    url,
    method: 'get',
    params: parameter
  })
}

// deleteRequest
export function deleteRequest(url, parameter) {
  return request({
    url,
    method: 'delete',
    params: parameter
  })
}

/**
 * @description 快捷发起请求
 * @param {Boolean} cache 是否缓存
 * @param {String} url 请求地址
 * @param {String} method 请求方式
 * @returns {Promise} 请求Promise
 */
 export async function quickRequest({ cache = false, url = "", method = "get" }) {
  const requestOption = { url, method };
  return await (cache ? cacheRequest : request)(requestOption);
}
